import React, { Component } from "react";
import { Link } from "react-router-dom";
import store from "../../../store";
import { SetPasswordAction, VerifyToken } from "../../../actions/user/login";
import { TO_EXTERNAL_LOGIN } from "../../../helpers/constants";
import { AuthShell, AuthStatus, PasswordField } from "../auth-shell";

class PasswordSetForm extends Component {
  state = {
    user: { password: "", confirmPassword: "", token: this.props.match.params.token },
    errors: {},
    tokenChecked: false,
    tokenValid: false,
    isSubmitting: false,
    complete: false,
    requestError: "",
  };

  componentDidMount() {
    store.dispatch(VerifyToken({ data: this.props.match.params.token }))
      .then((result) => this.setState({ tokenChecked: true, tokenValid: Boolean(result && result.status) }))
      .catch(() => this.setState({ tokenChecked: true, tokenValid: false }));
  }

  handleChange = (event) => {
    const { name, value } = event.target;
    this.setState((state) => ({ user: { ...state.user, [name]: value }, errors: { ...state.errors, [name]: "" } }));
  };

  validate = () => {
    const { password, confirmPassword } = this.state.user;
    const errors = {};
    if (!/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,128}$/.test(password)) errors.password = "Use 8+ characters with uppercase, lowercase, number, and special character.";
    if (confirmPassword !== password) errors.confirmPassword = "Passwords do not match.";
    this.setState({ errors });
    return Object.keys(errors).length === 0;
  };

  handleSubmit = async (event) => {
    event.preventDefault();
    if (!this.validate() || this.state.isSubmitting) return;
    this.setState({ isSubmitting: true, requestError: "" });
    const result = await store.dispatch(SetPasswordAction(this.state.user));
    if (result && result.status) {
      this.setState({ isSubmitting: false, complete: true });
    } else {
      this.setState({ isSubmitting: false, requestError: result && result.msg ? result.msg : "We couldn't update your password. Try again." });
    }
  };

  render() {
    if (!this.state.tokenChecked) {
      return <AuthShell eyebrow="Secure link" title="Checking your reset link" compact><AuthStatus type="info" icon="fa-circle-o-notch fa-spin" title="Verifying link"><p>This should only take a moment.</p></AuthStatus></AuthShell>;
    }

    if (!this.state.tokenValid) {
      return <AuthShell eyebrow="Secure link" title="Reset link unavailable" compact footer={<Link to={TO_EXTERNAL_LOGIN}>Back to sign in</Link>}><AuthStatus type="error" title="This link is invalid or has expired"><p>Request a new password reset link and try again.</p><Link className="auth-primary" to="/recover-password">Request another link</Link></AuthStatus></AuthShell>;
    }

    if (this.state.complete) {
      return <AuthShell eyebrow="Password updated" title="Your password is ready" compact><AuthStatus title="Password changed successfully"><p>Your reset link has been consumed. Sign in with your new password.</p><Link className="auth-primary" to={TO_EXTERNAL_LOGIN}>Continue to sign in</Link></AuthStatus></AuthShell>;
    }

    const { user, errors, isSubmitting } = this.state;
    return (
      <AuthShell eyebrow="Secure link" title="Choose a new password" description="Your new password must be strong and different from your previous password." compact footer={<Link to={TO_EXTERNAL_LOGIN}>Back to sign in</Link>}>
        <form className="auth-form" onSubmit={this.handleSubmit} noValidate>
          <PasswordField label="New password" id="new-password" name="password" autoComplete="new-password" value={user.password} onChange={this.handleChange} error={errors.password} />
          <PasswordField label="Confirm new password" id="confirm-new-password" name="confirmPassword" autoComplete="new-password" value={user.confirmPassword} onChange={this.handleChange} error={errors.confirmPassword} />
          {this.state.requestError && <div className="auth-inline-error" role="alert">{this.state.requestError}</div>}
          <button className="auth-primary" type="submit" disabled={isSubmitting}>{isSubmitting ? "Updating password..." : "Update password"}</button>
        </form>
      </AuthShell>
    );
  }
}

export default PasswordSetForm;
